var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSNar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.45;}\n\t.st1{fill:#829690;}\n\t.st2{fill:#F2691D;stroke:#FFFFFF;stroke-width:4.621;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 87.9,
    cy: 98,
    rx: 73.6,
    ry: 73.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 88.3,
    cy: 79.1,
    r: 73.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.3,145c14.3-4.3,26.8-14.9,32.9-28.7c0.6-1.5,1-2.8,0.6-4.5c-0.4-1.3-1.4-2.8-2.7-3.5 c-2.5-1.3-6.6-0.9-7.9,2.1c-1.3,3-2.9,5.8-4.8,8.5c-0.1,0.2-0.3,0.4-0.4,0.6c-0.4,0.5-0.3,0.4,0.2-0.3c0,0.2-0.6,0.7-0.7,0.9 c-0.5,0.6-1,1.1-1.5,1.7c-1.1,1.3-2.3,2.4-3.6,3.6c-0.6,0.5-1.2,1.1-1.9,1.6c-1,0.8,1-0.8,0,0c-0.4,0.3-0.7,0.5-1.1,0.8 c-1.3,0.9-2.7,1.8-4.1,2.6c-1.4,0.8-2.9,1.5-4.4,2.2c-0.4,0.2-0.2,0.1,0.5-0.2c-0.2,0.1-0.5,0.2-0.7,0.3 c-0.3,0.1-0.7,0.3-1.1,0.4c-0.8,0.3-1.7,0.6-2.5,0.8c-2.9,0.9-5,4.1-4,7.1C96.2,143.9,99.2,146,102.3,145L102.3,145z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSNar);
export default __webpack_public_path__ + "static/media/s_nar.1760db0d0a2c97783e01b673b88703c8.svg";
export { ForwardRef as ReactComponent };